<!-- <nz-drawer [nzBodyStyle]="{ height: 'calc(100% - 55px)', overflow: 'auto', 'padding-bottom': '0px' }"
    [nzMaskClosable]="false" [nzWidth]="720" [nzVisible]="visible" [nzTitle]="'Update Password'"
    (nzOnClose)="close()"> -->
<nz-modal nzWrapClassName="vertical-center-modal" [(nzVisible)]="visible" nzWidth='500' nzTitle="Reset Password" (nzOnCancel)="close()" (nzOnOk)="editPass()" [nzOkLoading]="isLoading">
    <!-- <div class="drawer-content"> -->
        <form nz-form [formGroup]="resetForm" id="userForm" class="user-form row" autocomplete="off">
            <nz-form-item class="col-12">
                <nz-form-control [nzErrorTip]="oldPassError">
                    <nz-form-label nzFor="oldPassword">Old Password</nz-form-label>
                    <nz-input-group>
                        <input type="password" nz-input id="oldPassword" formControlName="oldPassword" />
                    </nz-input-group>
                    <ng-template #oldPassError>
                        <span *ngIf="val.oldPassword.errors.required">Please provide old password!</span>
                        <span *ngIf="val.oldPassword.errors.pattern">Password should have 1 Capital and minimum 6
                            characters!</span>
                    </ng-template>
                </nz-form-control>
            </nz-form-item>
            <nz-form-item class="col-12">
                <nz-form-control [nzErrorTip]="passError">
                    <nz-form-label nzFor="password">Password</nz-form-label>
                    <nz-input-group>
                        <input type="password" nz-input id="password" formControlName="password" />
                    </nz-input-group>
                    <ng-template #passError>
                        <span *ngIf="val.password.errors.required">Please provide password!</span>
                        <span *ngIf="val.password.errors.pattern">Password should have 1 Capital and minimum 6
                            characters!</span>
                    </ng-template>
                </nz-form-control>
            </nz-form-item>
            <nz-form-item class="col-12">
                <nz-form-control [nzErrorTip]="confirmPassError">
                    <nz-form-label nzFor="confirmPassword">Confirm Password</nz-form-label>
                    <nz-input-group>
                        <input type="password" nz-input id="confirmPassword" formControlName="confirmPassword" />
                    </nz-input-group>
                    <ng-template #confirmPassError>
                        <span *ngIf="val.confirmPassword.errors.required">Please provide password same as above!</span>
                        <span *ngIf="val.confirmPassword.errors.pattern">Password should have 1 Capital and minimum 6
                            characters!</span>
                    </ng-template>
                </nz-form-control>
            </nz-form-item>
            <!-- <div class="col-12 d-flex justify-content-between align-items-end ">
                <div class=""></div>
                <button class="submit" nz-button type="submit" [nzLoading]="isLoading" (click)="editPass($event)" [nzType]="'primary'">Update</button>
            </div> -->
        </form>
    <!-- </div> -->
</nz-modal>
<!-- </nz-drawer> -->